import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ConfigurationAdminPage } from './configuration-admin';

@NgModule({
  declarations: [
    ConfigurationAdminPage,
  ],
  imports: [
    IonicPageModule.forChild(ConfigurationAdminPage),
  ],
})
export class ConfigurationAdminPageModule {}



// WEBPACK FOOTER //
// ./src/pages/configuration-admin/configuration-admin.module.ts